import { ApiError } from '@/lib/api';
import type { Messages } from '@/i18n/sv';

/** The user-facing text for a failed login or password request, in the page's language. */
export function authErrorMessage(error: unknown, t: Messages): string {
  if (!(error instanceof ApiError)) return t.auth.genericError;
  switch (error.code) {
    case 'UNAUTHENTICATED':
      return t.auth.wrongCredentials;
    case 'RATE_LIMITED':
      return t.auth.locked;
    case 'FORBIDDEN':
      return t.auth.suspended;
    case 'NOT_FOUND':
      // A password link that another tab used or that expired while the form was open
      return t.auth.linkInvalidText;
    default:
      // Network problems come with a readable message; server errors with a generic one
      return error.status === 0 ? t.common.errorMessage : t.auth.genericError;
  }
}

/** Checks a new password and its repeat; returns the error texts, empty when both are fine. */
export function newPasswordErrors(password: string, repeat: string, t: Messages) {
  const errors: { password?: string; repeat?: string } = {};
  if (password.length < 10) errors.password = t.auth.passwordTooShort;
  else if (password.length > 200) errors.password = t.auth.passwordTooLong;
  // Both values are what the person just typed in their own browser; timing reveals nothing to anyone else
  // nosemgrep: ajinabraham.njsscan.crypto.timing_attack_node.node_timing_attack
  else if (repeat !== password) errors.repeat = t.auth.passwordsDontMatch;
  return errors;
}
